var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slots-date"},[_c('div',{staticClass:"slots-date__header"},[_c('span',{staticClass:"slots-date__title"},[_vm._v(_vm._s(_vm.getFullDateDutch))])]),_vm._l((_vm.item),function(slotItem,name,index){return _c('location',{key:index,attrs:{"location":name,"items":slotItem,"fullDate":_vm.getFullDateDutch}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }